import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';

// import { URL_ROOT } from '../common/globalConstants.js';

/*
import Banner0 from '../assets/images/Banner0.jpg';
import Banner1 from '../assets/images/Banner1.jpg';
import Banner2 from '../assets/images/Banner2.jpg';
import Banner3 from '../assets/images/Banner3.jpg';
import Banner4 from '../assets/images/Banner4.jpg';
*/

const LandingPage = (props) => {

	const {
		// history,
		landingPageData
	} = props;

	return (
		<React.Fragment>
			<MetaTags>
				<title>AfterSchool Music</title>
				<meta name="description" content="Home page for AfterSchool Music" />
				<meta property="og:title" content="AfterSchool Music" />
			</MetaTags>
			<Header />
			<main>
				<div className='content'>
					{landingPageData.map(banner => {

						// const imagePath = require('../assets/images/' + banner.ImageUrl).default;
						const imagePath = 'https://storage.googleapis.com/afterschool-music.appspot.com/images/' + banner.ImageUrl;

						return (
							<div key={banner.id} className='landingPageBanner' style={{ backgroundImage: "url(" + imagePath + ")" }}>
								<div className='landingPageBannerOverlay'>
									<div className='landingPageBannerContent'>
										<h1>{banner.HeaderText}</h1>
										<p>{banner.Description}</p>
										{banner.HoverText && banner.HoverText.length > 0 && <p className='onHover'>{banner.HoverText}</p>}
										<Link to={banner.LinkUrl}>{'Learn more \u{279C}'}</Link>
									</div>
								</div>
							</div>
						);
					})}
					<br style={{clear: 'both'}} />
				</div>
			</main>
			<Footer />
		</React.Fragment>
	);
};

const mapStateToProps = state => {
	return {
		landingPageData: state.application.banners
	};
};

export default withRouter(connect(mapStateToProps, null)(LandingPage));
